export default "__VITE_ASSET__CPDpL9Bj__"